import { Button, JoonColorExpanded, Typography } from "@joonapp/web-shared"
import { useState } from "react"

import { useCheckoutRedirect } from "./paywall/useCheckoutRedirect"
import useDocumentTitle from "../hooks/useDocumentTitle"
import useMobile from "../hooks/useMobile"
import { AlertInterface } from "../types"
import { requireAuth } from "../util/auth"
import { localStorageItems } from "../util/storage"

function CheckoutPage() {
  useDocumentTitle("Joon - Special Pricing")
  const [formAlert, setFormAlert] = useState<AlertInterface>()
  const { redirectToFamilyCheckout } = useCheckoutRedirect()
  const isMobile = useMobile()

  const handleCheckout = async () => {
    try {
      await redirectToFamilyCheckout()
      localStorage.removeItem(localStorageItems.needsToSeePaywall)
    } catch (error) {
      setFormAlert({
        type: "error",
        message: "Failed to redirect to checkout.",
      })
    }
  }

  return (
    <div className="flex flex-col items-center gap-4 justify-center h-dvh bg-bgXLightGray">
      {isMobile && (
        <img
          src="/images/logos/logo_white.svg"
          alt="Special Pricing"
          className="h-[50px]"
        />
      )}
      <div className="flex flex-col items-center justify-center p-5 px-5 max-w-[300px] w-fit border border-borderPrimary rounded-lg bg-white">
        <Typography variant="h2Serif" textAlign="center" className="mb-4">
          You have access to special pricing!
        </Typography>

        <Button
          buttonType="primary"
          onClick={handleCheckout}
          text="Proceed to checkout"
        />
        {formAlert && (
          <div className="mt-4">
            <Typography variant="bodySmall" color={JoonColorExpanded.red400}>
              {formAlert.message}
            </Typography>
          </div>
        )}
      </div>
    </div>
  )
}

const CheckoutPageWithAuth = requireAuth(CheckoutPage)
export default CheckoutPageWithAuth
